const typeface = 'typeface';
const weight = 'weight';
export const aliasTypographyBuiltIns = {
    fontFamily: typeface,
    fontWeight: weight
};
export const aliasTypography = {
    ...aliasTypographyBuiltIns
};

//# sourceMappingURL=aliasTypography.js.map